import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';

/**
 * Gate für die Organisatoren-Seite.
 *
 * Wie AdminRoute reine UI-Bequemlichkeit, keine Sicherheitsgrenze: Wer die
 * Seite trotzdem öffnet, kann dort nichts anlegen - firestore.rules prüft
 * dieselbe Rolle noch einmal serverseitig.
 *
 * Anders als beim Admin steckt die Rolle NICHT im Token, sondern im
 * Profil-Dokument. Deshalb sitzt das Gate hinter dem Ladezustand des
 * AuthProviders: Solange das Profil noch nicht da ist, wäre isOrganizer
 * fälschlich false und würde den Organisator wegleiten.
 */
export default function OrganizerRoute({ children }) {
  const { user, loading, isOrganizer } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="mt-loading">
        <div className="mt-spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isOrganizer) {
    return <Navigate to="/intern" replace />;
  }

  return children;
}
